import React, { createContext, useContext } from "react";

const LayoutContext = createContext({
  sidebarOpen: true,
  setSidebarOpen: () => {},
  mobileDrawerOpen: false,
  setMobileDrawerOpen: () => {},
});

export function LayoutProvider({ value, children }) {
  return <LayoutContext.Provider value={value}>{children}</LayoutContext.Provider>;
}

export function useLayoutContext() {
  return useContext(LayoutContext);
}
